import { Flex, Typography, Card } from 'antd'
import { useTheme } from 'antd-style'

import { useTreatmentServiceGetTreatmentPlanAdverseEffectEntryEndpoint } from 'src/api/queries'
import {
  GetAdverseEffectEntryAdverseEffectListResponse2,
  GetTreatmentPlanAdverseEffectEntryListResponseItem
} from 'src/api/requests'
import { useLocales } from 'src/locales'

import { useStyles } from './styles'

const { Text } = Typography

type Props = {
  data?: GetTreatmentPlanAdverseEffectEntryListResponseItem
  treatmentPlanId?: string
  getReportedBy: (
    item?: GetTreatmentPlanAdverseEffectEntryListResponseItem
  ) => string
}

export const PersonReactionsListChildren = ({
  data,
  treatmentPlanId,
  getReportedBy
}: Props) => {
  const { t, currentLang } = useLocales()

  const { styles } = useStyles()

  const palette = useTheme()

  const { data: adverseReactionsDetails } =
    useTreatmentServiceGetTreatmentPlanAdverseEffectEntryEndpoint({
      id: String(treatmentPlanId),
      adverseEffectEntryId: String(data?.id)
    })

  return (
    <Card bordered={false} className={styles.collapseChildren}>
      <Flex vertical gap={16}>
        <Flex gap={4}>
          <Text strong>{t('consultations.accuse')}:</Text>
          <Text>
            {data?.adverseEffects
              ?.map(
                (item: GetAdverseEffectEntryAdverseEffectListResponse2) =>
                  item?.translation?.[currentLang?.value]
              )
              .join(', ') ?? '-'}
          </Text>
        </Flex>

        <Flex gap={4}>
          <Text strong>{t('common.comment')}:</Text>
          <Text>{adverseReactionsDetails?.comments}</Text>
        </Flex>

        <Text
          style={{
            color: palette.colorTextTertiary
          }}
        >
          {getReportedBy(data)}
        </Text>
      </Flex>
    </Card>
  )
}
